export const messages = {
  dismiss: {
    id: "toast.dismiss",
    defaultMessage: "Dismiss",
  },
};
